import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ICountriesDto, ICreateCountriesDto, IPagedCountryResultRequestDto, IUpdateCountriesDto } from 'src/app/models/backend';
import { PagedRequestDto, PagedResultDto } from 'src/app/shared/components/paged-listing-component-base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  id:any;
  constructor(private http:HttpClient) { }

// readonly url='https://localhost:7158/api/Countries/';
readonly url= environment.apiUrl+'Countries/'

Token = localStorage.getItem("Token")
headers = new HttpHeaders()
.set('Content-Type', 'application/json; charset=utf-8')
.set('Authorization', `Bearer ${this.Token}`);

    createCountry(CreateCountryDto:ICreateCountriesDto){
    return this.http.post<ICreateCountriesDto>(this.url+'CreateCountry',CreateCountryDto,{headers:this.headers})
    // .pipe(
    //   map(response =>
    //     {
    //       return response
    //     })
    // )
   
  }

  updateCountry(payload: IUpdateCountriesDto): Observable<ICountriesDto> {
    return this.http.post<ICountriesDto>(`${this.url}UpdateCountry`, payload,{headers:this.headers}).pipe(
      map(response => response)
    )
  }

  getCountries(payload:IPagedCountryResultRequestDto)
  {
    return this.http.post<PagedResultDto<ICountriesDto>>(this.url+'GetCountries',payload,{headers:this.headers});
  }

  GetActiveCountries()
  {
    return this.http.post<PagedResultDto<ICountriesDto>>(this.url+'GetActiveCountries',null,{headers:this.headers});
  }

  GetCountry(id: number): Observable<ICountriesDto> {
    return this.http.get<ICountriesDto>(`${this.url}GetCountry/${id}`,{headers:this.headers}).pipe(
      map(response => response)
    )
  }
  DeleteCountry(id: number){
    return this.http.post(`${this.url}DeleteCountry/${id}`,null,{headers:this.headers}).pipe(
      map(response => response)
    )
  }
}
